const { fetchNewsFeed: fetch } = require('../api/newsFeed');
const { actions } = require('../reducers/newsFeed');
const { newsSelector } = require('../selectors');

const MIN_NEWS_FEED_UPDATE = 1000 * 60 * 5; // 5 minutes
const FETCH_NEWS_FEED_TIMEOUT = 1000 * 30; // 30 seconds

function fetchInProgress() {
  return {
    type: actions.FETCH_IN_PROGRESS,
    timestamp: Date.now(),
  };
}

function fetchSuccessful(items, from) {
  return {
    type: actions.FETCH_SUCCESSFUL,
    items,
    from,
    timestamp: Date.now(),
  };
}

function fetchFailed(reason) {
  return {
    type: actions.FETCH_FAILED,
    reason,
    timestamp: Date.now(),
  };
}

function invalidateNews() {
  return {
    type: actions.INVALIDATE_NEWS,
  };
}

function fetchNewsFeed({ from, limit, sort } = {}) {
  return (dispatch, getState) => {
    dispatch(fetchInProgress());

    const state = getState();
    return fetch(state.auth.apiUrl, { from, limit, sort }).then(
      (items) => {
        dispatch(fetchSuccessful(items, from));
        return items;
      },
      (error) => {
        dispatch(fetchFailed(error));
        throw error;
      },
    );
  };
}

function shouldFetchNewsFeed(newsFeed, skipOutdatedCheck) {
  const {
    fetchingInProgressSince,
    lastSuccessfulFetch,
    didInvalidate,
    hasMore,
  } = newsFeed;

  if (
    !fetchingInProgressSince ||
    (fetchingInProgressSince &&
      Date.now() - fetchingInProgressSince > FETCH_NEWS_FEED_TIMEOUT)
  ) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    if (!hasMore) {
      return false;
    }
    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_NEWS_FEED_UPDATE)
    ) {
      return true;
    }
  }

  return false;
}

function fetchNewsFeedIfNeeded({ refresh = false, checkAge = false } = {}) {
  return (dispatch, getState) => {
    const newsFeed = newsSelector(getState());
    const { items, limit, lastSuccessfulFetch } = newsFeed;
    if (
      refresh ||
      (checkAge && Date.now() - lastSuccessfulFetch > MIN_NEWS_FEED_UPDATE)
    ) {
      dispatch(invalidateNews());
      return dispatch(fetchNewsFeed({ from: 0, limit }));
    }
    if (!checkAge && shouldFetchNewsFeed(newsFeed)) {
      return dispatch(fetchNewsFeed({ from: items.length, limit }));
    }
    return Promise.resolve();
  };
}

module.exports = {
  fetchNewsFeedIfNeeded,
  invalidateNews,
  fetchNewsFeed,
};
